// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"bf7730c3","977":"3530bd2d"}[chunkId] + ".chunk.js";
};